import axios from "axios";

const TOKEN_EXPIRATION_BUFFER = 2 * 60 * 1000; // 2 minutes before expiration
const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes

const authService = {
  setToken: (token) => {
    localStorage.setItem("authToken", token);
  },

  getToken: () => {
    return localStorage.getItem("authToken");
  },

  refreshToken: async (token) => {
    try {
      const response = await axios.post(
        "https://resplendent-warmth-production.up.railway.app/refresh-token",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newToken = response.data;
      authService.setToken(newToken);
      return newToken;
    } catch (error) {
      console.error("Failed to refresh token", error);
      authService.logout();
      throw error;
    }
  },

  checkTokenExpiration: (token, onTokenRenew) => {
    const tokenData = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = tokenData.exp * 1000;
    const currentTime = new Date().getTime();
    const timeUntilRefresh = expirationTime - currentTime - 60000;

    if (timeUntilRefresh <= 0) {
      onTokenRenew();
  } else {
      // Schedule the refresh
    //  setTimeout(refreshAuthToken, timeUntilRefresh);
  }
  },

  logout: () => {
    localStorage.removeItem("authToken");
    window.location.href = "/login"; // Redirect to login page
  },

  isInactive: (lastActivityTime) => {
    return new Date().getTime() - lastActivityTime > INACTIVITY_LIMIT;
  },
};

export default authService;
